import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VehicleInvoicesCtrl (
  $rootScope,
  $scope,
  $state,
  $translate,
  Invoice,
  sessionObjAPI,
  tableApi,
  workshopAPI
) {
  $scope.session             = sessionObjAPI.base();
  $scope.showVehicleInvoices = !!$scope.invoices.length;
  $scope.tableCacheKey       = 'vehicleInvoices';

  $scope.columns = [
    {
      field : 'invoice_number',
      header: {
        text: $translate.instant('INVOICE_SPACE.INVOICE_NUMBER')
      }
    },
    {
      field : 'post_date',
      header: {
        text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
      },
      pipe: 'globalDate'
    },
    {
      field : 'description',
      header: {
        text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
      }
    },
    {
      field : 'invoice_type',
      header: {
        text: $translate.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
      },
      pipe: 'invoiceType'
    },
    {
      field : 'invoice_status',
      header: {
        text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
      },
      pipe: 'invoiceStatus'
    },
    {
      field : 'total',
      header: {
        text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
      },
      pipe: 'globalCurrency'
    },
    {
      field : 'balance_due',
      header: {
        text: $translate.instant('JS_SPACE.COLUMNS.BALANCE')
      },
      pipe: 'globalCurrency'
    },
    {
      component: {
        bindings: {
          outputs: {
            onEditClick: event => $scope.viewInvoice(event)
          }
        },
        enabled: !$scope.vehicle.archived,
        factory: EditComponent,
      },
      sortable: false,
    }
  ];

  if ($rootScope.Company.isMultiBranch()) {
    $scope.columns.unshift({
      field : 'store_name',
      header: {
        text: 'Store Name'
      }
    });
  }

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: $scope.columns,
    empty  : {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 20, 50 ],
      queryCount: () => workshopAPI.get('/vehicles/invoice_count/' + $scope.vehicle.id)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    })
  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/vehicles/invoice_list', [
      $scope.vehicle.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if ( !$scope.vehicle.archived ) {
      $scope.viewInvoice(event.row);
    }
  };

  $scope.viewInvoice = function (event) {
    var invoice = new Invoice(event);

    if (invoice.isFromOutsideCompany()) {
      invoice.openReport('jasper_invoice', event.id);
    } else {
      $state.go('app.invoice', {
        customer_id: $scope.customer.id,
        id         : event.id,
        vehicle_id : event.vehicle_id
      });
    }
  };
};